module.exports = __webpack_public_path__ + "img/3-2-2.67ab753f.png";